export default "__VITE_ASSET__JtPf0POO__"